//src/components/admin/pagebuilder/EditModal

import React, { useState } from "react";

export default function EditModal({ component, onSave, onClose }) {
  const [data, setData] = useState(component.data || {});

  const handleImageUpload = (file) => {
    const url = URL.createObjectURL(file);
    setData((prev) => ({ ...prev, src: url }));
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded w-full max-w-lg">
        <h2 className="font-bold mb-4">
          Editar {component.type}
        </h2>

        {component.type === "text" && (
          <textarea
            className="w-full border p-2 h-32"
            value={data.text || ""}
            onChange={(e) =>
              setData({ ...data, text: e.target.value })
            }
          />
        )}

        {component.type === "image" && (
          <>
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                handleImageUpload(e.target.files[0])
              }
            />
            {data.src && (
              <img
                src={data.src}
                alt=""
                className="mt-4 rounded"
              />
            )}
          </>
        )}

        <div className="flex justify-end gap-3 mt-6">
          <button onClick={onClose}>Cancelar</button>
          <button
            onClick={() => onSave(data)}
            className="bg-indigo-600 text-white px-4 py-2 rounded"
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
}
